import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { cache, createQuery, localStorageCache } from '@farfetched/core';
import { signout } from '@features/common';
import * as api from './api';
import { GetTypePointPayload, GetTypePointResponse } from './types';

export const TypePointGate = createGate<GetTypePointPayload>();

const fxGetList = createEffect<GetTypePointPayload, GetTypePointResponse, Error>().use(
  api.getList
);

export const typePointQuery = createQuery({
  name: 'type-point',
  effect: fxGetList,
  mapData: ({ result }) => {
    const { types = [] } = result;
    if (types.length === 0) return [];
    return types.map(({ id, title }) => ({ id, label: title }));
  },
});

cache(typePointQuery, {
  adapter: localStorageCache({ maxAge: '5m' }),
  purge: signout,
});

sample({
  clock: TypePointGate.open,
  target: typePointQuery.start,
});
